<template>
	<div class="min-h-full flex flex-col viewport-max-width">
		<slot></slot>
	</div>
</template>
